import { useTranslation } from 'react-i18next';
import { PublicLayout } from '@/components/layout';

const Legal = () => {
  const { t } = useTranslation();

  return (
    <PublicLayout>
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <h1 className="text-3xl font-bold text-dark-800 dark:text-white mb-8">
          {t('legalNoticePage.title')}
        </h1>

        <div className="prose prose-gray max-w-none space-y-8">
          <section>
            <h2 className="text-xl font-semibold text-dark-800 dark:text-white mb-3">
              {t('legalNoticePage.publisherTitle')}
            </h2>
            <p className="text-gray-600 dark:text-gray-300 leading-relaxed">
              {t('legalNoticePage.publisherDescription')}
            </p>
            <ul className="list-none text-gray-600 dark:text-gray-300 mt-3 space-y-1">
              <li><strong>{t('legalNoticePage.publisherCompanyName')}</strong> Scalab Games</li>
              <li><strong>{t('legalNoticePage.publisherAddress')}</strong> 160 Avenue de Fès, 34080 Montpellier, France</li>
              <li><strong>{t('legalNoticePage.publisherSiret')}</strong> 93267579600019</li>
              <li><strong>{t('legalNoticePage.publisherEmail')}</strong> <a href="mailto:contact@scalab-games.com" className="text-lime-600 hover:text-lime-700 underline">contact@scalab-games.com</a></li>
            </ul>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-dark-800 dark:text-white mb-3">
              {t('legalNoticePage.directorTitle')}
            </h2>
            <p className="text-gray-600 dark:text-gray-300 leading-relaxed">
              {t('legalNoticePage.directorText')}
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-dark-800 dark:text-white mb-3">
              {t('legalNoticePage.hostTitle')}
            </h2>
            <p className="text-gray-600 dark:text-gray-300 leading-relaxed">
              {t('legalNoticePage.hostDescription')}
            </p>
            <ul className="list-none text-gray-600 dark:text-gray-300 mt-3 space-y-1">
              <li><strong>{t('legalNoticePage.hostCompanyName')}</strong> Google Cloud Platform (Firebase)</li>
              <li><strong>{t('legalNoticePage.hostCompany')}</strong> Google LLC</li>
              <li><strong>{t('legalNoticePage.hostAddress')}</strong> 1600 Amphitheatre Parkway, Mountain View, CA 94043, USA</li>
              <li><strong>{t('legalNoticePage.hostWebsite')}</strong> <a href="https://cloud.google.com" target="_blank" rel="noopener noreferrer" className="text-lime-600 hover:text-lime-700 underline">https://cloud.google.com</a></li>
            </ul>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-dark-800 dark:text-white mb-3">
              {t('legalNoticePage.ipTitle')}
            </h2>
            <p className="text-gray-600 dark:text-gray-300 leading-relaxed">
              {t('legalNoticePage.ipP1')}
            </p>
            <p className="text-gray-600 dark:text-gray-300 leading-relaxed mt-3">
              {t('legalNoticePage.ipP2')}
            </p>
            <p className="text-gray-600 dark:text-gray-300 leading-relaxed mt-3">
              {t('legalNoticePage.ipP3')}
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-dark-800 dark:text-white mb-3">
              {t('legalNoticePage.personalDataTitle')}
            </h2>
            <p className="text-gray-600 dark:text-gray-300 leading-relaxed">
              {t('legalNoticePage.personalDataP1')}
            </p>
            <p className="text-gray-600 dark:text-gray-300 leading-relaxed mt-3">
              {t('legalNoticePage.personalDataP2')} <a href="mailto:contact@scalab-games.com" className="text-lime-600 hover:text-lime-700 underline">contact@scalab-games.com</a>
            </p>
            <p className="text-gray-600 dark:text-gray-300 leading-relaxed mt-3">
              {t('legalNoticePage.personalDataP3')}{' '}
              <a href="/privacy" className="text-lime-600 hover:text-lime-700 underline">{t('legalNoticePage.personalDataLinkText')}</a>.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-dark-800 dark:text-white mb-3">
              {t('legalNoticePage.cookiesTitle')}
            </h2>
            <p className="text-gray-600 dark:text-gray-300 leading-relaxed">
              {t('legalNoticePage.cookiesText')}{' '}
              <a href="/cookies" className="text-lime-600 hover:text-lime-700 underline">{t('legalNoticePage.cookiesLinkText')}</a>.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-dark-800 dark:text-white mb-3">
              {t('legalNoticePage.liabilityTitle')}
            </h2>
            <p className="text-gray-600 dark:text-gray-300 leading-relaxed">
              {t('legalNoticePage.liabilityP1')}
            </p>
            <p className="text-gray-600 dark:text-gray-300 leading-relaxed mt-3">
              {t('legalNoticePage.liabilityP2')}
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-dark-800 dark:text-white mb-3">
              {t('legalNoticePage.linksTitle')}
            </h2>
            <p className="text-gray-600 dark:text-gray-300 leading-relaxed">
              {t('legalNoticePage.linksText')}
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-dark-800 dark:text-white mb-3">
              {t('legalNoticePage.lawTitle')}
            </h2>
            <p className="text-gray-600 dark:text-gray-300 leading-relaxed">
              {t('legalNoticePage.lawText')}
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-dark-800 dark:text-white mb-3">
              {t('legalNoticePage.creditsTitle')}
            </h2>
            <p className="text-gray-600 dark:text-gray-300 leading-relaxed">
              <strong>{t('legalNoticePage.creditsDesign')}</strong> Scalab Games
            </p>
            <p className="text-gray-600 dark:text-gray-300 leading-relaxed mt-2">
              <strong>{t('legalNoticePage.creditsIcons')}</strong> Lucide Icons
            </p>
            <p className="text-gray-600 dark:text-gray-300 leading-relaxed mt-2">
              <strong>{t('legalNoticePage.creditsFont')}</strong> Inter (Google Fonts)
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-dark-800 dark:text-white mb-3">
              {t('legalNoticePage.contactTitle')}
            </h2>
            <p className="text-gray-600 dark:text-gray-300 leading-relaxed">
              {t('legalNoticePage.contactText')} <a href="mailto:contact@scalab-games.com" className="text-lime-600 hover:text-lime-700 underline">contact@scalab-games.com</a>
            </p>
          </section>
        </div>

        <p className="text-sm text-gray-500 dark:text-gray-400 mt-12">
          {t('legalNoticePage.lastUpdated')}
        </p>
      </div>
    </PublicLayout>
  );
};

export default Legal;
